// extracted by mini-css-extract-plugin
export default {"container":"List_container__9Srdv","pagination":"List_pagination__nJTbO","action":"List_action__PBnai"};